/**
 * Was gesagt wird, wenn eine Abteilung keinen Platz für jemanden hat: Ihre Dataspaces begrenzen, wie
 * viele Personen gleichzeitig Prozesse darin geöffnet haben dürfen, und ein abgelehntes Schreiben oder eine
 * abgelehnte Prozessansicht sagt es auf dieselbe Weise (`utils/seats.ts`). Die eigene Seite des
 * Operators dafür ist `operator.seat`, die Seite der Plätze einer Abteilung `departments.seats`.
 */
export default {
	seats: {
		unavailable: {
			// Die Anzahl wählt die Form: keiner, einer, mehrere.
			named: "In {department} gibt es keinen Platz für Sie: Die Lizenz hat keine Floating-Plätze, und keiner ist für Sie reserviert. | Der einzige Floating-Platz in {department} ist belegt. | Alle {limit} Floating-Plätze in {department} sind belegt.",
			unnamed:
				"In dieser Abteilung gibt es keinen Platz für Sie: Die Lizenz hat keine Floating-Plätze, und keiner ist für Sie reserviert. | Der einzige Floating-Platz in dieser Abteilung ist belegt. | Alle {limit} Floating-Plätze in dieser Abteilung sind belegt.",
			// Der Server hat zu wenig gesagt, um damit zu zählen.
			anyNamed: "Alle Plätze in {department} sind belegt.",
			any: "Alle Plätze in dieser Abteilung sind belegt.",
			note: "Ein Platz wird etwa zwei Minuten, nachdem die Person ihn verlassen hat, wieder frei. Versuchen Sie es daher in Kürze erneut.",
			noteNone:
				"Bitten Sie einen Abteilungseigentümer um einen namentlichen Platz oder um eine Lizenz mit Floating-Plätzen.",
		},
	},
};
